import script from "./MapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MapEditor.vue?vue&type=script&setup=true&lang=js"

import "./MapEditor.vue?vue&type=style&index=0&id=fb460716&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb460716"]])

export default __exports__